import { render, staticRenderFns } from "./BkklistHome.vue?vue&type=template&id=33724a2b&"
import script from "./BkklistHome.vue?vue&type=script&lang=js&"
export * from "./BkklistHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports